import './MainNav.css'

// Reusable left sidebar shell used inside MainLayout. A thin action rail sits on
// the left; to its right is a vertical column of stacked slots:
//   location (header/location bar) -> search (search + filter) -> children (list)
//   -> footer (pinned to the bottom, e.g. the minimized-window dock)
function MainNav({ rail, location, search, children, footer }) {
  return (
    <aside className="main-nav">
      {rail}
      <div className="main-nav-main">
        {location}
        {search}
        {children}
        {footer}
      </div>
    </aside>
  )
}

export default MainNav
